module.exports = __webpack_public_path__ + "img/3.10cd7269.svg";